<router-outlet></router-outlet>
<div class="spinner-container" *ngIf="loading">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</div>